import createScript from '../../../../../../utils/create-script'

export const appendEbanxScript = () => {
    return createScript('ebanx-script', 'https://ebanx-js.ebanx.com/v1.55.0/dist/ebanx.min.js')
}